import React from 'react';
import FillPower from './FillPower';
import FillPowerGB from './FillPowerGB';
import Species from './Species';
import Origin from './Origin';
import Cleanliness from './Cleanliness';
import DownContent from './DownContent';
import Treatment from './Treatment';
import Processing from './Processing';
import Certification from './Certification';
import CM from './ColorMigration';
import Care from './Care';
import Sustainability from './Sustainability';
import { isRenu } from '../utils/ui.utils';

/**
 * ContentDetails (formerly ContentFace)
 * 
 * Modernized container for the detailed accordion content sections (content-ac).
 * Pairs with ContentSelector for BetaFlow navigation.
 */
export const ContentDetails = ({ 
  data, 
  activeSection, 
  onChange, 
  onClose, 
  impactData,
  showImpact,
  t
}) => {

  const handleChange = (event, id) => {
    // Ported from legacy ContentFace.handleChange
    let radios = document.querySelectorAll(".content-summary input");
    let checkboxes = document.querySelectorAll(".content-ac");

    for (let y = 0; y < checkboxes.length; y++) {
      checkboxes[y].classList.remove("active");
      checkboxes[y].classList.add("hide");
      // checkboxes[y].checked = false; // Checkboxes might not have 'checked' property directly
    }

    document.querySelector("body").className = "";
    document.querySelector("body").className = "loaded";
    document.querySelector("body").dataset.active = "lot";

    const contentFace = document.querySelector(".content-face");
    if (contentFace) {
        contentFace.classList.remove("active");
    }

    // handle input
    if (radios.length > 0) {
        radios[0].checked = true;
    }

    if (onClose) onClose("", "derp");
    if (onChange) onChange("", id);
  };

  return (
    <div className="content-face active">
      <FillPower
        b={data.brand}
        o={data.origin[0]}
        changeWord={handleChange}
        vFP={data.verified_fp}
        sFP={data.stated_fp}
        t={t}
      />
      {data.chinaDomestic === true ? (
        <FillPowerGB
          changeWord={handleChange}
          sFP_gb={data.stated_fp_gb}
          vFP_gb={data.verified_fp_gb}
          chinaDomestic={data.chinaDomestic}
          cdnLink={data.production_lot}
          t={t}
        />
      ) : null}
      <Species
        changeWord={handleChange}
        lotOrigin={data.prefix}
        lotSpecies={data.down_type}
        t={t}
      />
      <Origin
        changeWord={handleChange}
        lotOrigin={data.origin}
        lotSpecies={data.down_type}
        t={t}
      />
      <Cleanliness
        changeWord={handleChange}
        t_val={data.turbidity}
        o_val={data.oxygen}
        t={t}
      />
      <DownContent
        changeWord={handleChange}
        brand={data.prefix}
        cdnLink={data.production_lot}
        dc={data.down_cluster}
        lf={data.land_fowl}
        df={data.down_fiber}
        bf={data.broken_feather}
        ff={data.feather_fiber}
        q={data.quill}
        wf={data.waterfowl_feather}
        r={data.residue}
        report={data.rptLink}          
        t={t}
      />
      <Treatment
        changeWord={handleChange}          
        apply={data.treatment}
        t={t}
      />
      <Processing
        changeWord={handleChange}
        loc={data.facility != "" ? data.facility : "Los Angeles"}
        t={t}
      />
      <Certification
        display_lot={data.display_lot}        
        treatment={data.treatment}        
        brand={data.prefix}
        brandName={data.brandName}
        changeWord={handleChange}
        rds={data.rds}
        rsd={data.rsd}
        grs={isRenu(data.down_type) ? true : false}
        t={t}
      />
      <CM 
        changeWord={handleChange} 
        t={t} 
      />
      <Care
        changeWord={handleChange}
        t={t}
      />
      <Sustainability
        activeLot={data.display_lot}
        changeWord={handleChange}
        impactData={impactData}
        lotData={data}
        showImpact={showImpact}
        t={t}
      />
    </div>
  );
};

export default ContentDetails;
